import { render, staticRenderFns } from "./404.vue?vue&type=template&id=6c79bf65&scoped=true"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=6c79bf65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c79bf65",
  null
  
)

export default component.exports